import { render, staticRenderFns } from "./SelectHighlights.vue?vue&type=template&id=e877ee4e&scoped=true"
import script from "./SelectHighlights.vue?vue&type=script&lang=js"
export * from "./SelectHighlights.vue?vue&type=script&lang=js"
import style0 from "./SelectHighlights.vue?vue&type=style&index=0&id=e877ee4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e877ee4e",
  null
  
)

export default component.exports